import { CalculatedPriceRangeFragment } from '@graphql/generated';
import { Flex } from '@withjoy/joykit';
import React from 'react';
import { ZERO_STATE_PRICE_RANGES } from '../../constants';
import { useRegistryGiftCounts } from '../../RegistryGiftCounts.controller';
import { Page } from '../../telemetry';
import { PriceRangeV2 } from '../PriceRangeV2';
interface CountsByPriceProps extends Pick<ReturnType<typeof useRegistryGiftCounts>, 'getPriceRangeTitleAndLink' | 'priceRanges'> {
  page: Page;
  wrapItems: boolean;
  isOpen: boolean;
  closeDrawer?: () => void;
}

export const CountsByPriceV2 = ({ isOpen, priceRanges, getPriceRangeTitleAndLink, page, wrapItems, closeDrawer }: CountsByPriceProps) => {
  return (
    <>
      <Flex
        justifyContent="space-evenly"
        flexWrap={wrapItems ? 'wrap' : 'nowrap'}
        width="100%"
      >
        {(priceRanges || ZERO_STATE_PRICE_RANGES).map((priceRange: CalculatedPriceRangeFragment) => {
          const { title, priceRangeQuery } = getPriceRangeTitleAndLink(priceRange);
          return (
            <PriceRangeV2
              page={page}
              priceRangeQuery={priceRangeQuery}
              isOpen={isOpen}
              title={title}
              key={title}
              marginBottom={wrapItems ? 6 : 0}
              targetGiftCount={priceRange.targetGiftCount}
              completedGiftCount={priceRange.currentGiftCount}
              closeDrawer={closeDrawer}
            />
          );
        })}
      </Flex>
    </>
  );
};
